/**
 * DCTL-2484: the nav guard's permission decision, as a pure function.
 *
 * A route meta carries up to two permission keys, and they COMPOSE - both are
 * evaluated and both must pass:
 *
 *   - `permissions`    AND-logic. Every slug is required (`store.canAll`).
 *                      This is the original key; the 20 routes that use it are
 *                      unaffected by the addition of the second key.
 *   - `anyPermissions` OR-logic. At least one slug is required
 *                      (`store.canAny`).
 *
 * Composing rather than letting one key override the other means a route can
 * say "manage_units AND (manage_projects OR download_data)" without the guard
 * needing an expression grammar, and means adding `anyPermissions` to a route
 * that already has `permissions` narrows it rather than silently widening it.
 *
 * `canAll` / `canAny` both OR in the administrator bypass, matching the
 * backend's `can:` middleware (api/app/middleware/Can.ts).
 *
 * A meta with neither key is not gated, and this is never called for one - the
 * caller only reaches here after finding a record that carries at least one.
 */
export function routePermissionsAllowed(store, meta) {
	const { permissions, anyPermissions } = meta || {};
	if (permissions && !store.canAll(permissions)) return false;
	if (anyPermissions && !store.canAny(anyPermissions)) return false;
	return true;
}

/** Whether a route meta carries any permission gate at all. */
export function hasRoutePermissions(meta) {
	return Boolean(meta?.permissions || meta?.anyPermissions);
}
